"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const navigation_1 = require("./navigation");
const boxAnim_1 = require("./boxAnim");
const year_1 = require("./year");
const email_1 = require("./email");
document.addEventListener("DOMContentLoaded", () => {
    (0, navigation_1.initNav)();
    (0, boxAnim_1.initAnim)();
    (0, year_1.setCurentYear)();
    (0, email_1.initEmail)();
});
